"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_TIME_FORMAT = exports.EVENT_DATE_LABEL_FORMAT = exports.MONTH_NAMES = void 0;
const locales_1 = require("../enums/locales");
exports.MONTH_NAMES = {
    [locales_1.Locales.FR]: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
    ],
    [locales_1.Locales.EN]: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ],
    [locales_1.Locales.ES]: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ],
    [locales_1.Locales.DE]: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
    ],
};
exports.EVENT_DATE_LABEL_FORMAT = {
    en: "cccc, LLLL d",
    fr: "cccc d LLLL",
    es: "cccc d 'de' LLLL",
    de: "cccc, d. LLLL",
};
exports.EVENT_TIME_FORMAT = {
    en: "h:mm a",
    fr: "HH:mm",
    es: "h:mm a",
    de: "HH:mm",
};
